
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import CollectiveFeedbackForm from '@/components/feedback/collective/CollectiveFeedbackForm';
import { Users, ClipboardList, Mail, Info } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

const RequestCollectiveFeedback = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow bg-gray-50">
        <div className="container mx-auto px-4 pt-8">
          <div className="flex flex-col md:flex-row items-center mb-6 gap-3">
            <div className="w-12 h-12 rounded-full bg-brandBlue/10 flex items-center justify-center text-brandBlue">
              <Users size={24} />
            </div>
            <div>
              <h1 className="text-3xl font-bold">
                Demande de feedback collective
              </h1>
              <p className="text-gray-600 mt-1">
                Envoyez une demande de feedback à plusieurs destinataires simultanément
              </p>
            </div>
          </div>
          
          <div className="mb-8 bg-blue-50 rounded-lg p-4 border border-blue-100">
            <h2 className="font-semibold text-blue-800 mb-2 flex items-center">
              <ClipboardList className="h-5 w-5 mr-2" />
              Cas d'utilisation
            </h2>
            <ul className="list-disc list-inside text-blue-700 space-y-1">
              <li>Après un événement d'entreprise (conférence, séminaire)</li>
              <li>Suite à une formation dispensée à un groupe</li>
              <li>Pour évaluer des candidats après une session de recrutement collective</li>
              <li>Dans le cadre d'une réunion d'équipe ou d'un atelier</li>
            </ul>
          </div>
          
          <Alert className="mb-8 bg-amber-50 border-amber-200">
            <Info className="h-4 w-4 text-amber-700" />
            <AlertTitle className="text-amber-800">Information</AlertTitle>
            <AlertDescription className="text-amber-700">
              Importez facilement une liste d'emails via un fichier CSV/Excel ou en copiant-collant. 
              Tous les destinataires recevront un lien personnalisé pour vous donner leur feedback.
            </AlertDescription>
          </Alert>
        </div>
        
        <div className="container mx-auto px-4 pb-8">
          <CollectiveFeedbackForm />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default RequestCollectiveFeedback;
